/**
 * Credits Resource Client
 * Handles credits-related API operations
 */

import { ApiClient } from './apiClient';

export interface CreditTransaction {
    id: string;
    amount: number;
    type: 'earn' | 'spend' | 'adjustment';
    description: string;
    createdAt: string;
    sourceId: string | null;
    sourceType: string | null;
}

export interface CustomerCredits {
    balance: number;
    lifetimeEarned: number;
    lifetimeSpent: number;
    transactions: CreditTransaction[];
}

export interface RedeemProductResponse {
    success: boolean;
    orderId: string;
    creditsSpent: number;
    remainingCredits: number;
}

export class CreditsResource {
    constructor(private apiClient: ApiClient) { }

    /**
     * Get customer credit balance and transaction history
     */
    async getCustomerCredits(customerId: string, storeId: string): Promise<CustomerCredits> {
        return this.apiClient.get(`/api/v1/credits/balance/${customerId}/${storeId}`);
    }

    /**
     * Redeem a product using credits
     */
    async redeemProduct(data: {
        productId?: string;
        variantId: string;
        quantity?: number;
    }): Promise<RedeemProductResponse> {
        return this.apiClient.post('/api/v1/credits/redeem', data);
    }
}

